declare global {
  interface Window {
    __reloadCarts?: () => void;
  }
}

import { inject, Injectable, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { ShopCartActions } from '../actions';

/**
 * Registers the `window.__reloadCarts` helper used by Playwright tests
 * to trigger an Angular cart reload without a full page refresh.
 *
 * The bridge is registered unconditionally so it is available in every
 * environment where Playwright (or a developer) may need it.
 */
@Injectable({ providedIn: 'root' })
export class PlaywrightBridgeService {
  private readonly store: Store = inject(Store);
  private readonly zone: NgZone = inject(NgZone);

  constructor() {
    window.__reloadCarts = (): void => {
      this.zone.run((): void => {
        this.store.dispatch(ShopCartActions.loadCarts());
        this.store.dispatch(ShopCartActions.loadCurrentCartAndCartItems());
      });
    };
  }
}
